module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_4-WAY STRETCHABLE LEATHER_mobile.4d8e1a78.jpg";